import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';
import { SCENARIO_ID } from '@/context';

export const usePostHogAnalytics = () => {
  const postHog = usePostHog();

  const capture = useCallback(
    (event: PostHogEventEnum, properties?: Record<string, unknown>) => {
      postHog.capture(event, {
        scenario_id: SCENARIO_ID,
        ...properties,
      });
    },
    [postHog],
  );

  return { capture, postHog };
};
